import { useTranslation } from 'next-i18next';
import { ExtractedMaxLocations } from '@type/job-add';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';

/** Props */
interface JobMaxLocationsProps {
  maxLocations?: ExtractedMaxLocations[];
}

/**
 * @description Job Max Locations component.
 * - `maxLocations` - max locations.
 */
export const JobMaxLocations = (props: JobMaxLocationsProps) => {
  // Destructure props
  const { maxLocations } = props;

  // Translation
  const { t } = useTranslation();

  // Null if no max locations
  if (!maxLocations || !maxLocations.length) return null;

  // Render component
  // *******************
  return (
    <div className="mt-4 flex items-start gap-1.5 rounded bg-warning/10 p-2 md:mx-3.5">
      <ExclamationTriangleIcon className="size-5 shrink-0 text-warning" />
      <span className="text-sm">
        {`${t('job.max_locations.warning')}:`}
        {maxLocations.map((item) => (
          <span key={item.title}>
            {` ${t(item.title)} (${item.maxLocations})${maxLocations.length > 1 ? ',' : ''}`}
          </span>
        ))}
      </span>
    </div>
  );
};
